import { createContext } from 'react';

import type { FormValues } from 'src/app/pages/petitionDetails/shared/types';

export const MobileSignFormValuesContext = createContext<FormValues | null | undefined>(undefined);
export const MobileSignFormCallbackContext = createContext<((values: FormValues) => void) | undefined>(undefined);
